'use client';

/**
 * Mount-only: initializes PostHog once for the (app) route group. No context
 * value — call sites import `track` from `./events` directly, the same
 * pattern `lib/vocabulary.ts` uses for a module-level API instead of a
 * context. (app)-only; never import from `(marketing)/**` (eslint.config.mjs
 * no-restricted-imports wall).
 */
import { useEffect } from 'react';
import { initAnalytics } from './posthog';

export function AnalyticsProvider(): null {
  useEffect(() => {
    initAnalytics();
  }, []);
  return null;
}
